import React from 'react';
import { capitalize } from '../../utils/helpers';
import { useActiveModules } from '../../hooks/useActiveModules';

  const StudentDetails = ({ student, sessions, expandedSessions, toggleSession }) => {

  const { activeModules, activeModulesIds, activeModulesLoading, activeModulesError } = useActiveModules();

  // Add safety checks
  if (!student) {
    return <p>Loading student details...</p>;
  }

  if (activeModulesLoading) {
    return <p>Loading module information...</p>;
  }

  if (!sessions || Object.keys(sessions).length === 0) {  
     return (
        <div style={{ marginTop: "1rem" }}>
          <h3 style={{ color: "#405159" }}>
             {capitalize(student.student_first_name)} {capitalize(student.student_last_name)}'s Dialogues
          </h3>
          <p>No completed dialogues available.</p>
        </div> )
  }

  // Create a lookup map for module names
  const moduleNameMap = activeModules.reduce((acc, module) => {
    acc[module.module_id] = module.module_name;
    return acc;
  }, {});  

  return (
    <div style={{ marginTop: "1rem" }}>
        <h3 style={{ color: "#405159" }}>
            {capitalize(student.student_first_name)} {capitalize(student.student_last_name)}'s Dialogues
        </h3>

        {Object.entries(sessions).map(([sessionId, sessionData]) => {
          const { session_length, session_score, session_module_id, messages_dict, performance_summary, success_or_failure } = sessionData;
          const isExpanded = !!expandedSessions[sessionId];

          const resultSymbol = success_or_failure === "success"
            ? <span style={{ color: "green", marginLeft: "1rem" }}>✅</span>
            : success_or_failure === "failure"
              ? <span style={{ color: "red", marginLeft: "1rem" }}>❌</span>
              : null;

          return (
            <div key={sessionId} className="student-session-container">
              <button
                onClick={() => toggleSession(sessionId)}
                className="student-session-button"
                aria-expanded={isExpanded}
              >
                {isExpanded ? "▼" : "▶"}
                <span className="session-text">
                  Module {session_module_id}: {moduleNameMap[session_module_id] || 'Unknown Module'}
                  <em style={{ marginLeft: "2rem" }}>
                    Score: {session_score}     
                  </em> 
                  {resultSymbol}
                </span>
              </button>

              {isExpanded && (
                <div style={{ marginTop: "0.5rem", paddingLeft: "1rem" }}>
                  {performance_summary && (
                    <div style={{ marginTop: "1rem", fontStyle: "italic", color: "#444" }}>
                      <strong>Performance Summary:</strong> {performance_summary}
                    </div>
                  )}
                  <ul>
                    {messages_dict.map(({ system_or_user, message_text }, index) => (
                      <li key={index}>
                        <strong>{system_or_user}:</strong> {message_text}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        }
      )}
    </div>
  );
};

export default StudentDetails;
